<form autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <!--<button *ngIf="!visibilitySpinner" [disabled]="!habilitarGuardar" type="button" class="btn btn-outline-success" (click)="guardarTasas()"><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinner" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>-->
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">        
        <h4 style="display:inline">Atestaciones {{relacionAtestaciones.CodigoSolicitud}}</h4>
        <h5 style="display:inline; margin-left: 8px">
            <span>
                <!--***ICONOS***-->
                <img class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitudEx}}" ngbTooltip="{{tituloTipoSolicitud}}" />
                <!--<img class="asignada-icono" src="{{ null | IconoSolicitudAsignada}}" />-->
                <label class="codigo-icono-big" container="body" ngbTooltip="{{tituloTipoSolicitud}}">{{relacionAtestaciones.CodigoTipoSolicitud}}</label>
                <img class="estado-icono-big" container="body" src="{{relacionAtestaciones.IdEstadoSolicitudEx | IconoEstadoSolicitudEx}}" ngbTooltip="{{relacionAtestaciones.IdEstadoSolicitudExDescripcion}}" />
                <img *ngIf="relacionAtestaciones?.IdSubTipoSolicitudEx === tercerPaisConAtestFito || relacionAtestaciones?.IdSubTipoSolicitudEx === reExpConAtestFito || relacionAtestaciones?.IdSubTipoSolicitudEx === canariasConAtestFito"
                     class="estado-icono-big" src="{{relacionAtestaciones.IdSubTipoSolicitudEx | IconoTwTcSubTipoSolicitudEx}}" container="body" ngbTooltip="{{relacionAtestaciones.IdSubTipoSolicitudExDescripcion}}" />
                <img class="estado-icono-big" container="body" src="{{relacionAtestaciones.IdEstadoCertificadoFitoEx | IconoEstadoCertificadoFitoEx}}" ngbTooltip="{{relacionAtestaciones.IdEstadoCertificadoFitoExDescripcion}}" />
                <img *ngIf="relacionAtestaciones.IdResultadoEnvioMuestrasLaboratorioEx" class="estado-icono-big" container="body" src="{{relacionAtestaciones.IdResultadoEnvioMuestrasLaboratorioEx | IconoResultadoEnvioMuestraLaboratorio}}" ngbTooltip="{{relacionAtestaciones.DescripcionIdResultadoEnvioMuestrasLaboratorioEx}}" />
                <img *ngIf="esClonada" class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitudEx}}" ngbTooltip="Clonada" />
                <i *ngIf="esClonada" class="fa fa-clone clone-icono-big" ngbTooltip="Clonada"></i>
            </span>
        </h5>

        <div class="row">
            <div class="col-md-12">

                <ng-container *ngIf="idSolicitudEx">
                    <app-alertarechazo [id]="idSolicitudEx" [esExport]="true"></app-alertarechazo>
                </ng-container>

                <!--<div class="card card-accent-success animated fadeIn">-->
                <!--<div class="card-body-detalle">-->
                <!--GRID-->
                <div class="row">
                    <div class="col-md-12">
                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a">
                                <div class="card-header-buscador">
                                    <i class="fa fa-list"></i> Listado de Atestaciones
                                </div>
                            </a>

                            <div class="card-body-grid">

                                <p-table #tableSearch autoLayout="true" [value]="claveSolicitudAtestFitoCollection"
                                         [columns]="colsAtestacion" sortField="RefAtestFito" sortOrder="-1"
                                         styleClass="table table-responsive-sm table-striped table-sm table-0-marginbot"
                                         [ngClass]="displayGridHidden(claveSolicitudAtestFitoCollection)">

                                    <ng-template pTemplate="header" let-columns>
                                        <tr>
                                            <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                                {{col.header}}
                                                <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                                            </th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                                        <tr>

                                            <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                                <span *ngIf="(col.field!=='Link')">
                                                    {{rowData[col.field]}}
                                                </span>

                                                <div *ngIf="col.field==='Link'" class="btn-group">

                                                    <button (click)="onShowAtestacion(rowData)" type="button"
                                                            class="btn btn-sm btn-info">
                                                        <span class="fa fa-external-link"></span>
                                                    </button>

                                                </div>
                                            </td>
                                        </tr>

                                    </ng-template>
                                </p-table>
                                <div *ngIf="numeroAtestaciones === 0" class="empty-grid">
                                    No hay atestaciones asociadas a la solicitud
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!--</div>-->
                <!--</div>-->
            </div>

        </div>
    </div>

</form>
